import React from 'react';
import { withTranslation } from 'react-i18next';

import StandardTag from 'components/common/atoms/StandardTag';

import { createConsentScopeTagHandlers } from './ConsentScopeTag.helpers';
import { ConsentScopeTagProps } from './ConsentScopeTag.types';


function ConsentScopeTag({ value, t }: ConsentScopeTagProps) {
    const tagData = createConsentScopeTagHandlers({ value, t });

    return (
        <StandardTag
            color={tagData.color}
            value={tagData.text}
        />
    );
}

export default withTranslation('common')(ConsentScopeTag);
